import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

function Game() {
  const { gameId } = useParams();
  const navigate = useNavigate();
  const [time, setTime] = useState(300);
  const [GuessedWord, setGuessedWord] = useState("");
  const [message, setMessage] = useState("");
  const [redirectTimer, setRedirectTimer] = useState(10);
  const [temporaryMessage, setTemporaryMessage] = useState("");

  useEffect(() => {
    const timer = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          setMessage("Time's Up. You'll be redirected to the Friends page.");
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (message) {
      const redirectInterval = setInterval(() => {
        setRedirectTimer((prevTimer) => {
          if (prevTimer <= 1) {
            clearInterval(redirectInterval);
            navigate("/friends");
          }
          return prevTimer - 1;
        });
      }, 1000);
    }
  }, [message, navigate]);

  useEffect(() => {
    if (temporaryMessage) {
      const tempMessageTimer = setTimeout(() => {
        setTemporaryMessage("");
      }, 5000);
      return () => clearTimeout(tempMessageTimer);
    }
  }, [temporaryMessage]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  const submitWord = () => {
    axios
      .post(
        "https://verbalvortex-server.onrender.com/games/GuessedWord",
        {
          gameId: gameId,
          GuessedWord: GuessedWord,
        },
        {
          headers: {
            accessToken: localStorage.getItem("accessToken"),
          },
        }
      )
      .then((response) => {
        if (response.data.error) {
          setMessage("Word not found! You'll be redirected to the Friends page.");
        } else if (response.data.message === "Word already guessed, try another one") {
          setTemporaryMessage("Word already guessed, try another one");
        } else {
          setMessage("Word found! You'll be redirected to the Friends page.");
        }
      });
  };

  return (
    <div className="Game">
      <div id="Game__TimeLeft">Time left: {formatTime(time)}</div>
      {message ? (
        <div id="Game__Timer">
          <p>{message}</p>
          <p>Redirecting in {redirectTimer} seconds...</p>
        </div>
      ) : (
        <form>
          <input
            onChange={(event) => {
              setGuessedWord(event.target.value);
            }}
            type="text"
            placeholder="Type a word here!"
          />
          <button type="button" onClick={submitWord}>
            Guess
          </button>
        </form>
      )}
      {temporaryMessage && <div>{temporaryMessage}</div>}
    </div>
  );
}

export default Game;
